import Immutable from 'seamless-immutable';
import { handleActions } from 'redux-actions';
import { root as actionTypes } from '$constants/action-types';
import { router as routerActionTypes } from '$constants/action-types';

const defaultState = Immutable({
  loading: false,
  requestQueue: 0,
  title: '',
  shortTitle: '',
  notification: null,
  alert: null,
  passwordRequired: false
});

const reducer = {
  [actionTypes.SHOW_ALERT](state, action) {
    return state.set('alert', action.params);
  },

  [actionTypes.HIDE_ALERT](state) {
    return state.set('alert', null);
  },

  [actionTypes.SHOW_NOTIFICATION](state, action) {
    return state.set('notification', action.params);
  },

  [actionTypes.HIDE_NOTIFICATION](state) {
    return state.set('notification', null);
  },

  [actionTypes.CHANGE_TITLE](state, action) {
    return state.set('title', action.title)
                .set('shortTitle', action.shortTitle || action.title);
  },

  [routerActionTypes.CHANGE](state, action) {
    return state.set('notification', null);
  },

  [actionTypes.REQUEST](state) {
    return state.set('requestQueue', state.requestQueue + 1)
                .set('loading', true);
  },

  [actionTypes.RESPONSE](state) {
    return state.set('requestQueue', state.requestQueue - 1)
                .set('loading', state.requestQueue !== 1)
  },

  [actionTypes.REQUIRE_PASSWORD](state) {
    return state.set('passwordRequired', true);
  },

  [actionTypes.SUBMIT_PASSWORD](state) {
    return state.set('passwordRequired', false);
  }
}

export default handleActions(reducer, defaultState);



// WEBPACK FOOTER //
// ./src/reducers/root.js